export const targetingTypes = {
  TARGETING_TYPE_LANGUAGE: 'TARGETING_TYPE_LANGUAGE',
  TARGETING_TYPE_AGE_RANGE: 'TARGETING_TYPE_AGE_RANGE',
  TARGETING_TYPE_GENDER: 'TARGETING_TYPE_GENDER',
  TARGETING_TYPE_GEO_REGION: 'TARGETING_TYPE_GEO_REGION',
  TARGETING_TYPE_AUDIENCE_GROUP: 'TARGETING_TYPE_AUDIENCE_GROUP',
  TARGETING_TYPE_APP: 'TARGETING_TYPE_APP',
  TARGETING_TYPE_URL: 'TARGETING_TYPE_URL',
  TARGETING_TYPE_CATEGORY: 'TARGETING_TYPE_CATEGORY',
  TARGETING_TYPE_KEYWORD: 'TARGETING_TYPE_KEYWORD',
  TARGETING_TYPE_THIRD_PARTY_VERIFIER: 'TARGETING_TYPE_THIRD_PARTY_VERIFIER',
  TARGETING_TYPE_EXCHANGE: 'TARGETING_TYPE_EXCHANGE',
  TARGETING_TYPE_VIEWABILITY: 'TARGETING_TYPE_VIEWABILITY',
  TARGETING_TYPE_ON_SCREEN_POSITION: 'TARGETING_TYPE_ON_SCREEN_POSITION',
  TARGETING_TYPE_CONTENT_INSTREAM_POSITION: 'TARGETING_TYPE_CONTENT_INSTREAM_POSITION',
  TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION: 'TARGETING_TYPE_CONTENT_OUTSTREAM_POSITION',
  TARGETING_TYPE_CHANNEL: 'TARGETING_TYPE_CHANNEL',
  TARGETING_TYPE_NEGATIVE_KEYWORD_LIST: 'TARGETING_TYPE_NEGATIVE_KEYWORD_LIST'
}
